import { SingleEventPrediction } from "../SingleEventPrediction";
import { StagePointsTable } from "../../Scoring/StagePointsTables";
import { IEventUpdaterOnPointsChangeStrategy } from "./EventUpdaterOnPointsChangeStrategy";
import { immerable } from "immer";

export class Wsm2026EventUpdaterOnPointsChangeStrategy implements IEventUpdaterOnPointsChangeStrategy {
	[immerable] = true;

	public UpdateEventPredictionss(eventPredictions: Array<SingleEventPrediction>, _pointsTable: StagePointsTable): Array<SingleEventPrediction> {
		return eventPredictions;
	}
}
